export default {
  faqContactContainer: 'container px-15 md:px-0',
  hiddenClass: 'hidden',
  faqContact: 'contact-us',
  faqContactMain: 'bg-grey-lighter py-20 md:py-40 text-center md:px-15',
  faqContactdiv: 'container',
  faqContactIframe: 'iframe-component',
  compGenLabel: 'block text-grey-darker text-sm font-bold mb-2',
  compGenInput:
    'shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker',
  compGenInputPwd:
    'shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3',
  compGenBtn:
    'bg-blue hover:bg-blue-dark text-white font-bold py-2 px-4 rounded',
};
